export const EMPTY_CELL_VALUE = '-';
export const UNLIMITED = 'Unlimited';
export const BC_ALL_OTHER_CODE = 'BC - All Other';

export const CURRENCY_PRECISION = 2;
export const PERCENTAGE_PRECISION = 2;
export const NUMERIC_PRECISION = 0;
